import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {Button} from "primeng/button";
import {MessageService} from "primeng/api";
import {catchError, throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {ImageService} from "../../../data/services/image.service";
import {ImageDetail} from "../../../data/types/groups/types";

@Component({
    selector: 'app-delete-confirmation-dialog',
    standalone: true,
    imports: [
        DialogModule,
        Button
    ],
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrl: './delete-confirmation-dialog.component.css'
})
export class DeleteConfirmationDialogComponent {
    @Input({required: true}) dialogVisible!: boolean;


    @Output() onVisibilityChanged = new EventEmitter<boolean>();
    @Output() onSuccess = new EventEmitter<boolean>();

    imageService = inject(ImageService);
    messageService = inject(MessageService);

    protected image: ImageDetail | undefined
    protected selectedMakeId: number | undefined


    loading = false;
    failed = false;

    setImage(image: ImageDetail) {
        this.image = image;
    }

    setSelectedMakeId(id: number) {
        this.selectedMakeId = id
    }

    delete() {
        if (!this.image || !this.selectedMakeId) return

        this.loading = true;
        this.failed = false;

        this.imageService.deleteGroupImage(this.image, this.selectedMakeId).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe((response) => {
            this.loading = false;
            this.dialogVisible = false;
            this.onVisibilityChanged.emit(false);
            this.onSuccess.emit(true);
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully deleted'
            });
        });

    }

    handleError(error: HttpErrorResponse) {
        this.failed = true;
        this.loading = false;
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed delete the image'
        });
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

    close() {
        this.onVisibilityChanged.emit(false);
        this.dialogVisible = false;
    }
}
